import type { ComparisonRun } from "./simulatorComparisonTypes";

const STORAGE_PREFIX = "tessera_report_simulator_runs_v1:";

export type ReportSimulatorRunsSnapshot = {
  runs: ComparisonRun[];
  updatedAt: number;
};

function storageKey(reportId: string): string {
  return `${STORAGE_PREFIX}${reportId.trim()}`;
}

export function readReportSimulatorRuns(reportId: string | null | undefined): ComparisonRun[] {
  const id = reportId?.trim();
  if (!id || typeof window === "undefined") return [];
  try {
    const raw = window.sessionStorage.getItem(storageKey(id));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") return [];
    const runs = (parsed as { runs?: unknown }).runs;
    return Array.isArray(runs) ? (runs as ComparisonRun[]) : [];
  } catch {
    return [];
  }
}

export function writeReportSimulatorRuns(reportId: string | null | undefined, runs: ComparisonRun[]): void {
  const id = reportId?.trim();
  if (!id || typeof window === "undefined") return;
  try {
    const payload: ReportSimulatorRunsSnapshot = { runs, updatedAt: Date.now() };
    window.sessionStorage.setItem(storageKey(id), JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
}
